export enum HorizontalAlign {
    LEFT = 'LEFT',
    CENTER = 'CENTER',
    RIGHT = 'RIGHT',
}

export enum VerticalAlign {
    TOP = 'TOP',
    MIDDLE = 'MIDDLE',
    BOTTOM = 'BOTTOM',
}

export interface LabelAlignment {
    horizontal: HorizontalAlign;
    vertical: VerticalAlign;
}

export const DEFAULT_LABEL_ALIGNMENT: LabelAlignment = {
    horizontal: HorizontalAlign.CENTER,
    vertical: VerticalAlign.TOP,
};
